export default "__VITE_ASSET__8e89f669__"